// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * Reference to a parent record across modules. Used for the cross-module
 * Ask-Forseti integration (47.5.8). Type values match the corresponding
 * module's audit `resource_type`.
 */
/**
 * Sprint 47.5.8 — added 'incident_op' so the cross-module loop can scope
 * Forseti chats to incident-ops playbook activations.
 *
 * Sprint 47.5.8.4a — added 'dossier_filing' and 'transfer_assessment' so
 * the cross-module loop covers the full Privacy lane (DPIA + Dossier Filings
 * + Transfer Assessments + RoPA Activity + Rights Request).
 *
 * Sprint 47.5.8.4b — added 'vendor_contract', 'vendor_acceptance',
 * 'breach_notification', 'authority_request', 'supplement_request' for
 * the Risk + Vendor lane (Vendor + 3 vendor sub-records + 4 incident
 * sub-records).
 */
export const PARENT_RECORD_TYPES = [
    'project',
    'dpia',
    'dossier_filing',
    'transfer_assessment',
    'vendor',
    'vendor_contract',
    'vendor_acceptance',
    'incident',
    'incident_op',
    'breach_notification',
    'authority_request',
    'supplement_request',
    'rights_request',
    'contract',
    'task',
    'data_mapping_activity',
    'compliance_rule',
    'program',
    'governance_document',
    'remediation_plan',
    'cross_border_filing',
];
/** Hard cap for `AdvisorSummary.summary` — asserted at every adapter. */
export const ADVISOR_SUMMARY_MAX_CHARS = 400;
//# sourceMappingURL=ai-advisor.js.map